import { ClassificationExportConfig } from "../types/config";
import { ExportDestination } from "../types/destination";
import { MLExportRun } from "../types/run";

export const MOCK_DESTINATIONS: ExportDestination[] = [
  {
    destination: "roboflow",
    destination_label: "Roboflow",
    task_kind: "dump-image-classification",
    enabled: true,
    project_id: "boulder-detection-v2",
  },
  {
    destination: "hub_ai",
    destination_label: "Hub AI",
    task_kind: "dump-image-classification",
    enabled: true,
    project_id: "sample-classification",
  },
];

export const MOCK_CONFIGS: ClassificationExportConfig[] = [
  {
    id: 1,
    organization_id: 1,
    location_id: 1,
    machine_id: null,
    destination_id: null,
    export_only_valid_frames: true,
    export_only_model_mistakes: false,
    min_confidence: 0.5,
    max_confidence: null,
    created_at: "2025-06-01T10:00:00Z",
    updated_at: "2025-07-10T14:30:00Z",
  },
  {
    id: 2,
    organization_id: 1,
    location_id: 1,
    machine_id: 5,
    destination_id: null,
    export_only_valid_frames: true,
    export_only_model_mistakes: true,
    min_confidence: 0.3,
    max_confidence: 0.8,
    created_at: "2025-07-01T08:00:00Z",
    updated_at: "2025-07-15T09:00:00Z",
  },
];

export const MOCK_RUNS: MLExportRun[] = [
  {
    run_id: "run-abc-001",
    organization_id: 1,
    task_kind: "dump-image-classification",
    trigger: "adhoc_batch",
    input_mode: "image_ids",
    destination: { code: "roboflow", label: "Roboflow", project_id: "boulder-detection-v2" },
    status: { code: "SUCCESS", stage: "finished", error: null, is_terminal: true, is_success: true, is_running: false },
    timing: {
      created_at: "2025-07-20T10:00:00Z",
      started_at: "2025-07-20T10:00:05Z",
      finished_at: "2025-07-20T10:03:42Z",
      duration_seconds: 217,
    },
    progress: {
      percent: 100,
      uploaded: 847,
      total_candidates: 847,
      stage: "finished",
      stage_title: "Completed",
      stage_message: "Uploaded 847 / 847 images.",
      updated_at: "2025-07-20T10:03:42Z",
    },
    metrics: null,
    summary: {
      uploaded: 847,
      failed: 3,
      selection: {
        machines: [{ id: 3, name: "EH-740", device_mxid: "184430102141570F00" }],
        location: { id: 2, name: "Sigma Lithium" },
        organization: { id: 1, name: "Fagundes" },
      },
    },
  },
  {
    run_id: "run-abc-002",
    organization_id: 1,
    task_kind: "dump-image-classification",
    trigger: "adhoc_batch",
    input_mode: "image_ids",
    destination: { code: "hub_ai", label: "Hub AI", project_id: "sample-classification" },
    status: { code: "RUNNING", stage: "uploading", error: null, is_terminal: false, is_success: false, is_running: true },
    timing: {
      created_at: "2025-07-21T14:00:00Z",
      started_at: "2025-07-21T14:00:03Z",
      finished_at: null,
      duration_seconds: null,
    },
    progress: {
      percent: 62,
      uploaded: 310,
      total_candidates: 500,
      stage: "uploading",
      stage_title: "Uploading images",
      stage_message: "310 of 500 images uploaded",
      updated_at: new Date().toISOString(),
    },
    metrics: null,
    summary: {
      uploaded: 310,
      failed: 0,
      selection: {
        machines: [
          { id: 3, name: "EH-740", device_mxid: "184430102141570F00" },
          { id: 143347, name: "EH-742", device_mxid: "14442C1001D5CDD200" },
        ],
        location: { id: 2, name: "Sigma Lithium" },
        organization: { id: 1, name: "Fagundes" },
      },
    },
  },
];
